import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

const i18nInstance = i18n;

export const i18nPromise = i18n
  .use(HttpBackend) // Loads translations from your server/public path
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    supportedLngs: ["en-CA", "fr-CA", "es", "jp"],
    fallbackLng: "en-CA",
    load: "currentOnly",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    react: {
      useSuspense: true,
    },
    detection: {
      order: ["querystring", "cookie", "navigator"],
      lookupQuerystring: "lng",
      lookupCookie: "i18nextLng",
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",

      caches: ["cookie"],
      excludeCacheFor: ["cimode"],

      cookieOptions: {
        path: "/",
        sameSite: "strict",
        secure: process.env.NODE_ENV === "production",
      },
    },
  });

export { i18nInstance };
